export default {
  turnoExamen: {},
  turnoExamenes: [],
  errorArray: [],
  fields: {},
  record: {
    nuevo: false,
    actualizado: false,
  },
  pagination: {},
};
